export default __webpack_public_path__ + "static/media/file-structure-alt.e5e21c94.svg";